import { helpers } from '@vuelidate/validators';
import {
  arrayFileTypeValid,
  compareToDate,
  compareToDateAndDateTime,
  compareToDateAndEqual,
  compareToDateTime,
  compareToDateTimeAndDate,
  fileTypeValid,
  inputBlankTest,
  isEmailValid,
  isMaxLengthValid,
  isPasswordValid,
  isTelValid,
  isValidPhoneNumber,
  videoTypeValid
} from '@/common/utils/module/ValidSupport';
import { isApp, isEmpty, isIPad, isIPhone } from '@/common/utils/Util';
import { JOIN_TYPE } from '@/common/constants/ConstCode';

export const validationTouch = validObject => {
  validObject.value.$touch();
  return !validObject.value.$invalid;
};

export const validPropsTouch = validProps => {
  validProps.$touch();
  return !validProps.$invalid;
};

export const signInValid = {
  userId: {
    isEmpty: helpers.withMessage('이메일을 입력해 주세요.', value => !!value),
    isEmail: helpers.withMessage('이메일 형식에 맞게 입력해 주세요.', value => isEmailValid(value)),
    maxLength: helpers.withMessage('입력한 이메일 주소가 너무 깁니다. 50자 이하로 입력해 주세요.', value =>
      isMaxLengthValid(value, 51)
    )
  },
  password: {
    isEmpty: helpers.withMessage('비밀번호를 입력해 주세요.', value => !!value),
    isValid: helpers.withMessage('영문,숫자,특수기호 포함 6자리 이상 입력해 주세요.', (value, content) => {
      return isPasswordValid(value, 6);
    })
  }
};

export const signUp = {
  form: {
    name: {
      isEmpty: helpers.withMessage('이름을 입력해 주세요.', value => !!value),
      maxLength: helpers.withMessage('이름이 너무 깁니다. 10자 이하로 입력해 주세요.', value =>
        isMaxLengthValid(value, 11)
      )
    },
    userId: {
      isEmpty: helpers.withMessage('ID로 사용하실 이메일을 입력해 주세요.', (value, content) => {
        if (isEmpty(content.joinType)) {
          return !!value;
        } else {
          return true;
        }
      }),
      isEmail: helpers.withMessage('이메일 형식에 맞게 입력해 주세요.', (value, content) => {
        if (isEmpty(content.joinType)) {
          return isEmailValid(value);
        } else {
          return true;
        }
      }),
      maxLength: helpers.withMessage(
        '입력한 이메일 주소가 너무 깁니다. 50자 이하로 입력해 주세요.',
        (value, content) => {
          if (isEmpty(content.joinType)) {
            return isMaxLengthValid(value, 51);
          } else {
            return true;
          }
        }
      )
    },
    password: {
      isEmpty: helpers.withMessage('비밀번호를 입력해 주세요.', (value, content) => {
        if (isEmpty(content.joinType)) {
          return !!value;
        } else {
          return true;
        }
      }),
      isValid: helpers.withMessage('영문,숫자,특수기호 포함 6자리 이상 입력해 주세요.', (value, content) => {
        if (isEmpty(content.joinType)) {
          return isPasswordValid(value, 6);
        } else {
          return true;
        }
      })
    },
    birthDate: {
      isEmpty: helpers.withMessage('생년월일을 선택해 주세요.', (value, content) => {
        if (!isApp() || (!isIPhone() && !isIPad())) {
          return !!value;
        } else {
          return true;
        }
      })
    }
  },
  isAgreeService: {
    isValid: helpers.withMessage('필수 이용약관에 동의해주세요', (value, content) => {
      if (!content.isAgreePrivacy) return false;
      return !!content.isAgreeService;
    })
  }
};
export const memorialImageValid = {
  backgroundImageNo: {
    isEmpty: helpers.withMessage('추모관 배경이미지를 선택해 주세요.', value => {
      return !isEmpty(value);
    })
  }
};

export const memorialValid = {
  imageFile: {
    isEmpty: helpers.withMessage('고인의 사진을 등록해 주세요.', value => {
      return !isEmpty(value);
    })
  },
  family: {
    isEmpty: helpers.withMessage('고인과의 관계를 입력해 주세요.', value => {
      if (isEmpty(value)) return false;
      for (const element of value) {
        const item = element;
        if (item['relation'] === '선택') {
          return false;
        }
        for (const key in item) {
          if (item[key] === '' || item[key] === null || item[key] === undefined) {
            return false;
          }
        }
      }
      return true;
    }),
    isLength: helpers.withMessage('10자 이내로 입력해 주세요.', value => {
      return !value.some(item => item.name.length > 10);
    })
  },
  deadName: {
    isEmpty: helpers.withMessage('고인의 성함을 입력해 주세요.', value => !isEmpty(value)),
    isLength: helpers.withMessage('성함이 너무 깁니다. 10자 이하로 입력해 주세요.', value => {
      return value.length <= 10;
    })
  },
  birthDate: {
    isEmpty: helpers.withMessage('고인의 생년월일을 입력해 주세요.', value => !isEmpty(value)),
    isDeath: helpers.withMessage('생년월일이 소천일보다 늦을 수 없습니다.', (value, content) => {
      return compareToDate(value, content.deathDate);
    })
  },
  deathDate: {
    isEmpty: helpers.withMessage('고인의 소천일을 입력해 주세요.', value => !isEmpty(value))
  },
  // churchNo: {
  //   isEmpty: helpers.withMessage('교회를 등록하시려면 교회정보를 검색후 선택해 주세요.', (value, content) => {
  //     return !(!isEmpty(content.churchText) && isEmpty(value));
  //   })
  // },
  churchJob: {
    isEmpty: helpers.withMessage('교회를 등록하시려면 직책을 선택해주셔야합니다.', (value, content) => {
      return !(!isEmpty(content.churchNo) && isEmpty(value));
    })
  }
};

export const memorialSecondValid = {
  family: {
    isEmpty: helpers.withMessage('고인과의 관계를 입력해 주세요.', value => {
      if (isEmpty(value)) return false;
      for (const element of value) {
        const item = element;
        if (item['relation'] === '선택') {
          return false;
        }
        for (const key in item) {
          if (item[key] === '' || item[key] === null || item[key] === undefined) {
            return false;
          }
        }
      }
      return true;
    }),
    isLength: helpers.withMessage('10자 이내로 입력해 주세요.', value => {
      return !value.some(item => item.name.length > 10);
    })
  },
  deadName: {
    isEmpty: helpers.withMessage('고인의 성함을 입력해 주세요.', value => !isEmpty(value)),
    isLength: helpers.withMessage('성함이 너무 깁니다. 10자 이하로 입력해 주세요.', value => {
      return value.length <= 10;
    })
  },
  birthDate: {
    isEmpty: helpers.withMessage('고인의 생년월일을 입력해 주세요.', value => !isEmpty(value))
  },
  churchJob: {
    isEmpty: helpers.withMessage('교회를 등록하시려면 직책을 선택해주셔야합니다.', (value, content) => {
      return !(!isEmpty(content.churchNo) && isEmpty(value));
    })
  }
};

export const funeralUpdateValid = {
  imageFile: {
    isEmpty: helpers.withMessage('고인의 사진을 등록해주세요', (value, content) => {
      return !(isEmpty(content.funeralNo) && isEmpty(value));
    })
  },
  deadName: {
    isEmpty: helpers.withMessage('고인의 성함을 입력해 주세요.', value => !isEmpty(value))
  },
  birthDate: {
    isEmpty: helpers.withMessage('고인의 생년월일을 입력해 주세요.', value => !isEmpty(value)),
    isDeath: helpers.withMessage('생년월일이 소천일보다 늦을 수 없습니다.', (value, content) => {
      return compareToDate(value, content.deathDate);
    }),
    isOnlineStart: helpers.withMessage('생년월일이 장례시작일보다 늦을 수 없습니다.', (value, content) => {
      if (content.isOnline) {
        if (isEmpty(value)) return false;
        return compareToDate(value, content.onlineStartDate);
      }
      return true;
    }),
    isOnlineEnd: helpers.withMessage('생년월일이 장례마감일보다 늦을 수 없습니다.', (value, content) => {
      if (content.isOnline) {
        if (isEmpty(value)) return false;
        return compareToDate(value, content.onlineEndDate);
      }
      return true;
    })
  },
  deathDate: {
    isEmpty: helpers.withMessage('고인의 소천일을 입력해 주세요.', value => !isEmpty(value))
  },
  family: {
    isEmpty: helpers.withMessage('고인과의 관계를 입력해 주세요.', value => {
      if (isEmpty(value)) return false;
      for (const element of value) {
        const item = element;
        if (item['relation'] === '선택') {
          return false;
        }
        for (const key in item) {
          if (item[key] === '' || item[key] === null || item[key] === undefined) {
            return false;
          }
        }
      }
      return true;
    }),
    nameLength: helpers.withMessage('성함이 너무 깁니다. 10자 이하로 입력해 주세요.', value => {
      if (isEmpty(value)) return false;
      for (const element of value) {
        if (element['name'].length > 10) {
          return false;
        }
      }
      return true;
    })
  },

  onlineStartDate: {
    isEmpty: helpers.withMessage('장례식장 시작일자를 선택해 주세요.', (value, content) => {
      if (content.isOnline) {
        if (isEmpty(value)) return false;
      }
      return true;
    }),
    isEndDate: helpers.withMessage('시작일이 마감일보다 늦을 수 없습니다.', (value, content) => {
      if (content.isOnline) {
        if (isEmpty(value)) return false;
        return compareToDate(value, content.onlineEndDate);
      }
      return true;
    })
  },
  onlineEndDate: {
    isEmpty: helpers.withMessage('장례식장 마감일자를 선택해 주세요.', (value, content) => {
      if (content.isOnline) {
        if (isEmpty(value)) return false;
      }
      return true;
    })
  }
};
export const funeralValid = {
  imageFile: {
    isEmpty: helpers.withMessage('고인의 사진을 등록해주세요', (value, content) => {
      if (isEmpty(content.announcementNo) && content.isOnline && isEmpty(value)) return false;
      return true;
    })
  },
  deadName: {
    isEmpty: helpers.withMessage('고인의 성함을 입력해 주세요.', value => !isEmpty(value)),
    maxLength: helpers.withMessage('고인의 성함이 너무 깁니다. 10자 이하로 입력해 주세요.', value =>
      isMaxLengthValid(value, 11)
    )
  },
  birthDate: {
    isEmpty: helpers.withMessage('고인의 생년월일을 입력해 주세요.', value => !isEmpty(value)),
    isDeath: helpers.withMessage('생년월일이 소천일보다 늦을 수 없습니다.', (value, content) => {
      return compareToDate(value, content.deathDate);
    }),
    isCarry: helpers.withMessage('생년월일이 발인일보다 늦을 수 없습니다.', (value, content) => {
      return compareToDateAndDateTime(value, content.carryDate);
    }),
    isOnlineStart: helpers.withMessage('생년월일이 장례시작일보다 늦을 수 없습니다.', (value, content) => {
      if (content.isOnline) {
        if (isEmpty(value)) return false;
        return compareToDate(value, content.onlineStartDate);
      }
      return true;
    }),
    isOnlineEnd: helpers.withMessage('생년월일이 장례마감일보다 늦을 수 없습니다.', (value, content) => {
      if (content.isOnline) {
        if (isEmpty(value)) return false;
        return compareToDate(value, content.onlineEndDate);
      }
      return true;
    })
  },
  deathDate: {
    isEmpty: helpers.withMessage('고인의 소천일을 입력해 주세요.', value => !isEmpty(value)),
    isCarry: helpers.withMessage('소천일이 발인일보다 늦을 수 없습니다.', (value, content) => {
      return compareToDateAndDateTime(value, content.carryDate);
    }),
    isOnlineStart: helpers.withMessage('소천일이 장례시작일보다 늦을 수 없습니다.', (value, content) => {
      if (content.isOnline) {
        if (isEmpty(value)) return false;
        let deathDate = new Date(value);
        let onlineStartDate = new Date(content.onlineStartDate);

        return deathDate <= onlineStartDate;
      }
      return true;
    }),
    isOnlineEnd: helpers.withMessage('소천일이 장례마감일보다 늦을 수 없습니다.', (value, content) => {
      if (content.isOnline) {
        if (isEmpty(value)) return false;
        return compareToDate(value, content.onlineEndDate);
      }
      return true;
    })
  },
  family: {
    isEmpty: helpers.withMessage('고인과의 관계를 입력해 주세요.', value => {
      if (isEmpty(value)) return false;
      for (const element of value) {
        const item = element;
        if (item['relation'] === '선택') {
          return false;
        }
        for (const key in item) {
          if (item[key] === '' || item[key] === null || item[key] === undefined) {
            return false;
          }
        }
      }
      return true;
    }),
    nameLength: helpers.withMessage('성함이 너무 깁니다. 10자 이하로 입력해 주세요.', value => {
      if (isEmpty(value)) return false;
      for (const element of value) {
        if (element['name'].length > 10) {
          return false;
        }
      }
      return true;
    })
  },
  address: {
    isEmpty: helpers.withMessage('장례식장 주소를 입력해 주세요.', value => !isEmpty(value))
  },
  funeralName: {
    isEmpty: helpers.withMessage('장례식장 이름을 입력해 주세요.', value => !isEmpty(value))
  },
  funeralRoom: {
    isEmpty: helpers.withMessage('빈소를 입력해 주세요.', value => !isEmpty(value))
  },
  // casketDate: {
  //   isEmpty: helpers.withMessage('입관일을 선택해 주세요.', value => !isEmpty(value)),
  //   isCarry: helpers.withMessage('입관일이 발인일보다 늦을 수 없습니다.', (value, content) => {
  //     return compareToDate(value, content.carryDate);
  //   })
  // isOnlineStart: helpers.withMessage('입관일이 장례시작일보다 늦을 수 없습니다.', (value, content) => {
  //   if (content.isOnline) {
  //     if (isEmpty(value)) return false;
  //     return compareToDateTimeAndDate(value, content.onlineStartDate);
  //   }
  //   return true;
  // }),
  // isOnlineEnd: helpers.withMessage('입관일이 장례마감일보다 늦을 수 없습니다.', (value, content) => {
  //   if (content.isOnline) {
  //     if (isEmpty(value)) return false;
  //     return compareToDateTimeAndDate(value, content.onlineEndDate);
  //   }
  //   return true;
  // })
  // },
  carryDate: {
    isEmpty: helpers.withMessage('발인일을 선택해 주세요.', value => !isEmpty(value))
    // isOnlineStart: helpers.withMessage('발인일이 소천일보다 늦을 수 없습니다.', (value, content) => {
    //   if (content.isOnline) {
    //     if (isEmpty(value)) return false;
    //     return compareToDateTimeAndDate(value, content.onlineStartDate);
    //   }
    //   return true;
    // }),
    // isOnlineEnd: helpers.withMessage('발인일이 장례마감일보다 늦을 수 없습니다.', (value, content) => {
    //   if (content.isOnline) {
    //     if (isEmpty(value)) return false;
    //     return compareToDateTimeAndDate(value, content.onlineEndDate);
    //   }
    //   return true;
    // })
  },
  bank: {
    isEmpty: helpers.withMessage('은행을 선택해 주세요.', (value, model) => {
      if (!model.isOnline) return true;
      if (!model.canUseEmoticon) return true;
      return !isEmpty(value);
    })
  },
  depositor: {
    isEmpty: helpers.withMessage('예금주를 입력해 주세요.', (value, model) => {
      if (!model.isOnline) return true;
      if (!model.canUseEmoticon) return true;
      return !isEmpty(value);
    })
  },
  accountNumber: {
    isEmpty: helpers.withMessage('계좌번호를 입력해 주세요.', (value, model) => {
      if (!model.isOnline) return true;
      if (!model.canUseEmoticon) return true;
      return !isEmpty(value);
    })
  },
  onlineStartDate: {
    isEmpty: helpers.withMessage('온라인 장례식장 시작일을 선택해 주세요.', (value, content) => {
      if (content.isOnline) {
        if (isEmpty(value)) return false;
      }
      return true;
    }),
    isAfter: helpers.withMessage('소천일 이후로 선택해 주세요.', (value, content) => {
      if (content.isOnline) {
        if (isEmpty(value)) return false;
        return compareToDateAndEqual(content.deathDate, value);
      }
      return true;
    }),
    isEndDate: helpers.withMessage('시작일이 마감일보다 늦을 수 없습니다.', (value, content) => {
      if (content.isOnline) {
        if (isEmpty(value)) return false;
        return compareToDate(value, content.onlineEndDate);
      }
      return true;
    })
  },
  onlineEndDate: {
    isEmpty: helpers.withMessage('온라인 장례식장 마감일자를 선택해 주세요.', (value, content) => {
      if (content.isOnline) {
        if (isEmpty(value)) return false;
      }
      return true;
    }),
    isDays: helpers.withMessage('온라인 장례식장은 최대 30일까지 선택 가능합니다.', (value, content) => {
      if (content.isOnline) {
        if (isEmpty(value)) return false;
        const startDate = new Date(content.onlineStartDate);
        const endDate = new Date(value);
        const maxEndDate = new Date(startDate);
        maxEndDate.setDate(startDate.getDate() + 30); // 100일 추가
        if (endDate > maxEndDate) return false;
      }
      return true;
    })
  }
};

export const memorialTicketValid = {
  itemHistoryNo: {
    isEmpty: helpers.withMessage('추모관 이용권을 선택해 주세요.', value => !isEmpty(value))
  }
};

export const inputValid = {
  searchText: {
    isEmpty: helpers.withMessage('검색어를 입력해 주세요.', value => !!value)
  }
};

export const churchApplyValid = {
  churchName: {
    isEmpty: helpers.withMessage('교회 이름을 입력해 주세요.', value => !!value)
  },

  roadAddress: {
    isEmpty: helpers.withMessage('교회 주소를 입력해 주세요.', value => !!value)
  }
};
export const familyTextValid = {
  searchText: {
    isEmpty: helpers.withMessage('가족코도를 입력해 주세요.', value => !!value)
  }
};
export const familyUpdateValid = {
  familyName: {
    isEmpty: helpers.withMessage('변경하려는 가족 명칭을 입력해 주세요.', value => !!value),
    maxLength: helpers.withMessage('가족명칭을 20자 이하로 입력해 주세요.', value => isMaxLengthValid(value, 21))
  }
};

export const aliveValid = {
  title: {
    isEmpty: helpers.withMessage('제목을 입력해 주세요.', value => !!value),
    maxLength: helpers.withMessage('제목을 20자 이하로 입력해 주세요.', value => isMaxLengthValid(value, 21))
  }
  // contents: {
  //   isEmpty: helpers.withMessage('내용을 입력해 주세요.', value => !!value),
  //   maxLength: helpers.withMessage('내용을 100자 이하로 입력해 주세요.', value => isMaxLengthValid(value, 101))
  // },
  // firstRawFile: {
  //   isEmpty: helpers.withMessage('이미지를 업로드 해주세요.', (value, content) => {
  //     return !(
  //       isEmpty(content.firstImageFileInfo) &&
  //       isEmpty(content.secondImageFileInfo) &&
  //       isEmpty(content.secondRawFile) &&
  //       isEmpty(value)
  //     );
  //   })
  // },
  // firstImageFileInfo: {
  //   isEmpty: helpers.withMessage('이미지를 업로드 해주세요', (value, content) => {
  //     return !(
  //       isEmpty(content.firstRawFile) &&
  //       isEmpty(content.secondImageFileInfo) &&
  //       isEmpty(content.secondRawFile) &&
  //       isEmpty(value)
  //     );
  //   })
  // },
  // secondRawFile: {
  //   isEmpty: helpers.withMessage('이미지를 업로드 해주세요', (value, content) => {
  //     return !(
  //       isEmpty(content.firstImageFileInfo) &&
  //       isEmpty(content.secondImageFileInfo) &&
  //       isEmpty(content.firstRawFile) &&
  //       isEmpty(value)
  //     );
  //   })
  // },
  // secondImageFileInfo: {
  //   isEmpty: helpers.withMessage('이미지를 업로드 해주세요', (value, content) => {
  //     return !(
  //       isEmpty(content.firstImageFileInfo) &&
  //       isEmpty(content.firstRawFile) &&
  //       isEmpty(content.secondRawFile) &&
  //       isEmpty(value)
  //     );
  //   })
  // }
  // imageFile: {
  //   isEmpty: helpers.withMessage('이미지를 업로드 해주세요', value => {
  //     return !isEmpty(value);
  //   })
  // }
};

export const passwordValid = {
  password: {
    isEmpty: helpers.withMessage('비밀번호를 입력해 주세요.', value => !!value),
    isValid: helpers.withMessage('영문,숫자,특수기호 포함 6자리 이상 입력해 주세요.', (value, content) => {
      return isPasswordValid(value, 6);
    })
  }
};

export const nonMemberValid = {
  name: {
    isEmpty: helpers.withMessage('조문객 이름을 기재해주세요.', value => !!value),
    maxLength: helpers.withMessage('이름이 너무 깁니다. 10자 이하로 입력해 주세요.', value =>
      isMaxLengthValid(value, 11)
    )
  }
};

export const idValid = {
  userId: {
    isEmpty: helpers.withMessage('이메일을 입력해 주세요.', value => !!value),
    isEmail: helpers.withMessage('이메일 형식에 맞게 입력해 주세요.', value => isEmailValid(value))
  }
};

export const boardRegistervalid = {
  title: {
    isEmpty: helpers.withMessage('제목을 입력해 주세요.', value => {
      return inputBlankTest(value);
    }),
    maxLength: helpers.withMessage('제목을 20자 이하로 입력해 주세요.', value => isMaxLengthValid(value, 21))
  },
  contents: {
    isEmpty: helpers.withMessage('내용을 입력해 주세요.', value => {
      return inputBlankTest(value);
    }),
    maxLength: helpers.withMessage('내용을 1000자 이하로 입력해 주세요.', value => isMaxLengthValid(value, 1001))
  },
  imageFile: {
    isEmpty: helpers.withMessage('이미지를 업로드 해주세요', value => {
      return !isEmpty(value);
    }),
    isType: helpers.withMessage('업로드한 파일이 이미지 파일이 아닙니다.', value => {
      return arrayFileTypeValid(value);
    })
  }
};

export const inquiryRegisterValid = {
  title: {
    isEmpty: helpers.withMessage('제목을 입력해 주세요.', value => {
      return inputBlankTest(value);
    }),
    maxLength: helpers.withMessage('제목을 20자 이하로 입력해 주세요.', value => isMaxLengthValid(value, 21))
  },
  contents: {
    isEmpty: helpers.withMessage('내용을 입력해 주세요.', value => {
      return inputBlankTest(value);
    }),
    maxLength: helpers.withMessage('내용을 1000자 이하로 입력해 주세요.', value => isMaxLengthValid(value, 1001))
  },
  phone: {
    isEmpty: helpers.withMessage('휴대전화 번호를 입력해주세요.', (value, model) => {
      if (!isEmpty(model.userNo)) return true;
      return !isEmpty(value);
    })
  },
  name: {
    isEmpty: helpers.withMessage('이름 번호를 입력해주세요.', (value, model) => {
      if (!isEmpty(model.userNo)) return true;
      return !isEmpty(value);
    })
  }
};

export const lawRegistervalid = {
  title: {
    isEmpty: helpers.withMessage('제목을 입력해 주세요.', value => {
      return inputBlankTest(value);
    }),
    maxLength: helpers.withMessage('제목을 20자 이하로 입력해 주세요.', value => isMaxLengthValid(value, 21))
  },
  contents: {
    isEmpty: helpers.withMessage('내용을 입력해 주세요.', value => {
      return inputBlankTest(value);
    }),
    maxLength: helpers.withMessage('내용을 1000자 이하로 입력해 주세요.', value => isMaxLengthValid(value, 1001))
  },
  imageFile: {
    isType: helpers.withMessage('업로드한 파일이 이미지 파일이 아닙니다.', value => {
      if (value.length === 0) return true;
      return arrayFileTypeValid(value);
    })
  }
};

export const moreRegisterValid = {
  title: {
    isEmpty: helpers.withMessage('제목을 입력해 주세요.', value => {
      return inputBlankTest(value);
    }),
    maxLength: helpers.withMessage('제목을 20자 이하로 입력해 주세요.', value => isMaxLengthValid(value, 21))
  },
  contents: {
    isEmpty: helpers.withMessage('내용을 입력해 주세요.', value => {
      return inputBlankTest(value);
    }),
    maxLength: helpers.withMessage('내용을 1000자 이하로 입력해 주세요.', value => isMaxLengthValid(value, 1001))
  },
  firstRawFile: {
    isEmpty: helpers.withMessage('이미지를 업로드 해주세요', (value, content) => {
      return !(
        isEmpty(content.firstFileInfo) &&
        isEmpty(content.secondFileInfo) &&
        isEmpty(content.secondRawFile) &&
        isEmpty(value)
      );
    })
  },
  firstFileInfo: {
    isEmpty: helpers.withMessage('이미지를 업로드 해주세요', (value, content) => {
      return !(
        isEmpty(content.firstRawFile) &&
        isEmpty(content.secondFileInfo) &&
        isEmpty(content.secondRawFile) &&
        isEmpty(value)
      );
    })
  },
  secondRawFile: {
    isEmpty: helpers.withMessage('이미지를 업로드 해주세요', (value, content) => {
      return !(
        isEmpty(content.firstFileInfo) &&
        isEmpty(content.secondFileInfo) &&
        isEmpty(content.firstRawFile) &&
        isEmpty(value)
      );
    })
  },
  secondFileInfo: {
    isEmpty: helpers.withMessage('이미지를 업로드 해주세요', (value, content) => {
      return !(
        isEmpty(content.firstFileInfo) &&
        isEmpty(content.firstRawFile) &&
        isEmpty(content.secondRawFile) &&
        isEmpty(value)
      );
    })
  }
};

export const RETURN_VALID = {
  contents: {
    isEmpty: helpers.withMessage('내용을 입력해 주세요.', value => {
      return inputBlankTest(value);
    })
  }
};

// 별도의 Vuelidate가아닌 자체 유효성 메시지 저장용
export const CUSTOM_VALID_MESSAGE = {
  signInValid: {
    notFound: '로그인 정보가 올바르지 않습니다. 다시 시도해주세요.'
  }
};
